import Translation from '../Translation/cont/Translation'
import isAllCinemas from '../../functions/isAllCinemas'

const CinemaBadgeList = ({ resolvedCinemaIds, allCinemaIds, cinemas, fallbackShort }) => {
    const uniqueCinemaIds = Array.from(new Set(resolvedCinemaIds))

    if (uniqueCinemaIds.length === 0 && fallbackShort) {
        return <span className="tmdb-badge tmdb-badge--cinema text-small-light">{fallbackShort}</span>
    }
    if (isAllCinemas(uniqueCinemaIds, allCinemaIds)) {
        return <span className="tmdb-badge tmdb-badge--all text-small-light"><Translation id="alle_button" /></span>
    }
    return uniqueCinemaIds.map(id => {
        const cinema = cinemas && cinemas[id]
        return cinema ? (
            <span key={id} className="tmdb-badge tmdb-badge--cinema text-small-light">{cinema.nameShort || cinema.name}</span>
        ) : null
    })
}

export default CinemaBadgeList
